import React, { useState } from 'react';
import {
    Box,
    Drawer,
    IconButton,
    Tooltip,
    useTheme,
    useMediaQuery
} from '@mui/material';
import {
    Menu as MenuIcon,
    MenuOpen as MenuOpenIcon
} from '@mui/icons-material';
import SessionsList from './SessionsList';

const ChatSidebar = ({ 
    onSessionSelect, 
    currentSessionId, 
    onNewSession,
    open = true,
    onToggle
}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [isCollapsed, setIsCollapsed] = useState(false);

    const sidebarWidth = isCollapsed ? 60 : 300;

    const handleToggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };

    const sidebarContent = (
        <Box sx={{ 
            width: sidebarWidth,
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            transition: 'width 0.3s ease',
            borderRight: 1,
            borderColor: 'divider'
        }}>
            {/* Collapse Toggle */}
            {!isMobile && (
                <Box sx={{ 
                    display: 'flex', 
                    justifyContent: isCollapsed ? 'center' : 'flex-end',
                    p: 1,
                    borderBottom: 1,
                    borderColor: 'divider'
                }}>
                    <Tooltip title={isCollapsed ? "Expand sidebar" : "Collapse sidebar"}>
                        <IconButton size="small" onClick={handleToggleCollapse}>
                            {isCollapsed ? <MenuIcon /> : <MenuOpenIcon />}
                        </IconButton>
                    </Tooltip>
                </Box>
            )}

            {/* Sessions List */}
            <Box sx={{ flex: 1, overflow: 'hidden' }}>
                <SessionsList
                    onSessionSelect={onSessionSelect}
                    currentSessionId={currentSessionId}
                    onNewSession={onNewSession}
                    isCollapsed={isCollapsed}
                />
            </Box>
        </Box>
    );

    if (isMobile) {
        return (
            <Drawer
                variant="temporary"
                open={open}
                onClose={onToggle}
                ModalProps={{
                    keepMounted: true, // Better mobile performance
                }}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: 300,
                        boxSizing: 'border-box',
                    },
                }}
            >
                {sidebarContent}
            </Drawer>
        );
    }

    return (
        <Box
            component="nav"
            sx={{
                width: open ? sidebarWidth : 0,
                flexShrink: 0,
                transition: 'width 0.3s ease',
                overflow: 'hidden'
            }}
        >
            {open && sidebarContent}
        </Box>
    );
};

export default ChatSidebar; 